import { render, staticRenderFns } from "./EnvRecomm.vue?vue&type=template&id=cc8c6560&"
import script from "./EnvRecomm.vue?vue&type=script&lang=js&"
export * from "./EnvRecomm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports